import { render, staticRenderFns } from "./TagsTypeColumn.vue?vue&type=template&id=118f89b8"
import script from "./TagsTypeColumn.vue?vue&type=script&lang=js"
export * from "./TagsTypeColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports